module.exports = __webpack_public_path__ + "img/escola_creative_learning_odontopediatria.71588689.jpeg";